module.exports = __webpack_public_path__ + "img/indexbanner.72c4e845.jpg";